module.exports = __webpack_public_path__ + "a4dc39560e90a33b37b40ff2a73962ee.jpg";